import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { sharedClasses } from '../../Components';
import { styles } from '../styles';
import Api from '../API';

export const renderAutocomplete = <T extends { name: string }>(
  label: string,
  value: T | null,
  options: T[],
  onChange: (value: T | null) => void,
  disabled = false,
  error = false,
  helperText?: string,
  ref?: React.RefObject<HTMLInputElement>
) => (
  <Autocomplete
    disablePortal
    value={value}
    options={options}
    getOptionLabel={(option) => option.name}
    onChange={(_event, newValue) => onChange(newValue)}
    disabled={disabled}
    sx={{
      ...sharedClasses.formAutocomplete,
      width: '100%',
      paddingTop: 3,
      '.MuiInputBase-root': { margin: '3px 0px' }
    }}
    slotProps={{ listbox: { style: sharedClasses.autoCompleteListStyles } }}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        slotProps={{ inputLabel: { shrink: true } }}
        placeholder="Please select"
        sx={styles.editCandidateAutocompleteTextfield}
        required={error}
        error={error}
        helperText={helperText}
        ref={ref}
      />
    )}
  />
);

export const useAutocompleteUtils = () => {
  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await Api.getCountriesStates();
        setCountries(data.res?.countries || []);
        setStates(data.res?.states || []);
      } catch (error) {
        console.error('Error fetching countries and states:', error);
        setCountries([]);
        setStates([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return {
    countries,
    states,
    isLoading
  };
};
